// Generated by CoffeeScript 1.12.7
(function() {
  var defaultValue, dereference, faker, generateExample;

  dereference = require('./dereference');

  defaultValue = require('./default-value');

  faker = require('faker/locale/en');

  generateExample = function(root, context) {
    var i, item, j, key, len, len1, member, obj, ref, ref1, ref2, ref3, ref4, ref5, ref6, results, value;
    switch (root.element) {
      case 'boolean':
      case 'string':
      case 'number':
        if (root.content != null) {
          return root.content;
        } else {
          if (((ref = root.attributes) != null ? ref["default"] : void 0) !== void 0) {
            return root.attributes["default"];
          } else {
            if ((ref1 = root.meta) != null ? ref1.id : void 0) {
              context.path.push(root.meta.id.toLowerCase());
            }
            value = context.defaultValue(root, context.path);
            if ((ref2 = root.meta) != null ? ref2.id : void 0) {
              context.path.pop();
            }
            return value;
          }
        }
        break;
      case 'enum':
        return generateExample(root.content[0], context);
      case 'array':
        ref3 = root.content || [];
        results = [];
        for (i = 0, len = ref3.length; i < len; i++) {
          item = ref3[i];
          results.push(generateExample(item, context));
        }
        return results;
        break;
      case 'object':
        obj = {};
        ref4 = root.content;
        for (j = 0, len1 = ref4.length; j < len1; j++) {
          member = ref4[j];
          if (member.element === 'select') {
            member = member.content[0].content[0];
          }
          key = member.content.key.content;
          if ((ref5 = root.meta) != null ? ref5.id : void 0) {
            context.path.push(root.meta.id.toLowerCase());
          }
          context.path.push(key.toLowerCase());
          obj[key] = member.content.value ? generateExample(member.content.value, context) : context.defaultValue({
            element: 'string'
          }, context.path);
          context.path.pop();
          if ((ref6 = root.meta) != null ? ref6.id : void 0) {
            context.path.pop();
          }
        }
        return obj;
      default:
        return null;
    }
  };

  module.exports = function(root, dataStructures, options) {
    var example, origPath;
    if (options == null) {
      options = {};
    }
    if (options.defaultValue == null) {
      options.defaultValue = defaultValue;
    }
    origPath = options.path;
    if (options.path == null) {
      options.path = [];
    }
    if (options.seed) {
      faker.seed(options.seed);
    }
    example = generateExample(dereference(root, dataStructures), options);
    options.path = origPath;
    return example;
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/eidolon/lib/example.js
// module id = 225
// module chunks = 0